import { useDispatch } from 'react-redux'
import { BasicCollapsible, SelectionSet, ColorSwatches } from '@vp/swan'

import { useFilterOptions } from '~/app/features/Gallery/components/Filters/SingleSelect/useFilterOptions'
import { buildRefinement, refinementAddAndRemove } from '~/app/store/refinement'
import { REFINEMENT_DIMENSION } from 'shared/constants'
import { scrollUpToElement } from '~/app/utils/scrollToElement'
import { galleryHeaderId } from '~/app/features/Gallery/components/Header/ActionHeader/constants'
import { isFilterModalHidden } from '~/app/features/Gallery/components/Header/ActionHeader/components/FilterMenu/utils'
import { ThunkDispatch } from '~/app/store/interface'
import { ColorOption } from '~/app/features/Gallery/components/Filters/ProductColor/ColorOption'

export const ProductColor = ({ filter }: { filter: State.Filter }) => {
  const { options, selected, visible } = useFilterOptions(filter as State.AttributeFilter)
  const dispatch = useDispatch<ThunkDispatch>()

  const selectedValue = selected || options[0]?.value

  const handleSelectedValueChange = (newSelectedValue: string | null): void => {
    if (!newSelectedValue) {
      return
    }

    const refinement = buildRefinement(newSelectedValue, REFINEMENT_DIMENSION.ATTRIBUTE)
    const oldRefinement = buildRefinement(selected, REFINEMENT_DIMENSION.ATTRIBUTE)

    dispatch(refinementAddAndRemove([refinement], [oldRefinement]))
    if (isFilterModalHidden()) {
      scrollUpToElement(galleryHeaderId)
    }
  }

  if (!visible) {
    return null
  }

  return (
    <BasicCollapsible aria-label={filter.title} className="filter" collapsibleId={filter.name} heading={filter.title} headingLevel="h4">
      <SelectionSet aria-label={filter.title} selectedValue={selectedValue} variant="single-select" onSelectedValueChange={handleSelectedValueChange}>
        <ColorSwatches size="super">
          {options.map((option) => (
            <ColorOption
              key={option.value}
              disabled={option.disabled}
              value={option.value}
              title={option.title}
              primaryColor={option.productOption.optionValue}
            />
          ))}
        </ColorSwatches>
      </SelectionSet>
    </BasicCollapsible>
  )
}
